import {
  SOURCE_SYNC_AMOUNT_FIELDS,
  SOURCE_SYNC_DATE_FIELDS,
} from "constants/invoiceSourceSync";
import { SourceSyncChange } from "types/Models/invoiceSourceSync";
import { currency } from "utils/Currency";
import { formatDate } from "utils/formatDate";

const EMPTY_VALUE = "—";

// Display text for one side of a source-sync diff
export const formatSourceSyncValue = (
  field: SourceSyncChange["field"],
  value: SourceSyncChange["inkle"],
  currencyCode?: string | null
): string => {
  if (value === null || value === "") {
    return EMPTY_VALUE;
  }

  if (typeof value === "boolean") {
    return value ? "Yes" : "No";
  }

  if (SOURCE_SYNC_AMOUNT_FIELDS.includes(field)) {
    return currency({ amount: value, currencyCode });
  }

  if (SOURCE_SYNC_DATE_FIELDS.includes(field)) {
    return formatDate(value);
  }

  return value;
};
